import { render, staticRenderFns } from "./ContactNameComponent.vue?vue&type=template&id=651973c1"
import script from "./ContactNameComponent.vue?vue&type=script&lang=ts"
export * from "./ContactNameComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports